const INVALID_PREFIXES = ['BG', 'GB', 'NK', 'KN', 'TN', 'NT', 'ZZ']

export const validateNino = (value: string): boolean => {
  if (!value || value.trim() === '' || value.trim() === '""') {
    return true
  }

  const sanitized = value.replace(/[\s-]/g, '').toUpperCase()

  const niPattern = /^[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z][0-9]{6}[A-D]$/

  if (!niPattern.test(sanitized)) {
    return false
  }

  const prefix = sanitized.substring(0, 2)
  return !INVALID_PREFIXES.includes(prefix)
}
